// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

type BackendResult<T> = {
  isSuccess: boolean;
  code: number;
  message?: string;
  value?: T;
};

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  const r = await request<BackendResult<API.CurrentUser>>('/api/admin/currentUser', {
    method: 'GET',
    ...(options || {}),
  });

  if (r?.isSuccess !== true || !r?.value) {
    throw new Error(r?.message || '未登录');
  }

  return { data: r.value };
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(body?: { refreshToken?: string }, options?: { [key: string]: any }) {
  const r = await request<BackendResult<any>>('/api/admin/auth/login/outLogin', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });

  return r as any;
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  const r = await request<BackendResult<API.LoginResult>>('/api/admin/auth/login/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });

  if (r?.isSuccess !== true || !r?.value) {
    return {
      success: false,
      status: 'error',
      type: body?.type,
      currentAuthority: 'guest',
    };
  }

  return r.value;
}

/** 刷新 access token POST /api/auth/refresh */
export async function refreshAccessToken(body: { refreshToken: string }, options?: { [key: string]: any }) {
  const r = await request<BackendResult<{ accessToken: string }>>('/api/admin/auth/refresh', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });

  return {
    success: r?.isSuccess,
    accessToken: r?.value?.accessToken,
  };
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
